import { dashboardAction } from '../../Store/Reducers/DashboardReducer';
import { isContent } from '../../Utils/Response/Response';
import { getRejectReason } from '../Api/InitiateAPI';

export async function fetchRejectReason(token, dispatch,notify) {
  await getRejectReason(token,dispatch,notify,response=> dispatch(dashboardAction.setRejectReason(isContent(response))));
}